import React from 'react';
import { motion } from 'framer-motion';

const PARTICLE_COUNT = 80;
const COLOR = "#e7c17f";

const ParticleExplosion = () => {
    // Generate particles only once
    const particles = React.useMemo(() => {
        return Array.from({ length: PARTICLE_COUNT }).map((_, i) => {
            const angle = Math.random() * 360;

            // MASSIVE EXPLOSION radius (keeps the "big" feel)
            // Radius: 600px to 1800px 
            const distance = 600 + Math.random() * 1200;

            // FINE PARTICLES (Standard confetti size)
            // Size: 8px to 16px (Significantly smaller than 24-54px)
            const size = 8 + Math.random() * 8;

            const x = Math.cos(angle * (Math.PI / 180)) * distance;
            const y = Math.sin(angle * (Math.PI / 180)) * distance;

            return {
                id: i,
                x,
                y,
                size,
                rotation: Math.random() * 360,
                duration: 1.0 + Math.random() * 1.5,
            };
        });
    }, []);

    return (
        <div style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            pointerEvents: 'none',
            zIndex: 0,
            width: 0,
            height: 0
        }}>
            {particles.map((p) => (
                <motion.div
                    key={p.id}
                    initial={{ x: 0, y: 0, opacity: 1, scale: 0.5, rotate: 0 }}
                    animate={{
                        x: p.x,
                        y: p.y,
                        opacity: 0,
                        scale: 0,
                        rotate: p.rotation
                    }}
                    transition={{
                        duration: p.duration,
                        ease: "easeOut"
                    }}
                    style={{
                        position: 'absolute',
                        width: p.size,
                        height: p.size,
                        backgroundColor: COLOR,
                        borderRadius: '2px', // Sharper corners for small confetti
                    }}
                />
            ))}
        </div>
    );
};

export default ParticleExplosion;
